// extracted by mini-css-extract-plugin
export default {"managePointsModal":"AdminUpdatePoints_managePointsModal__pqJk8","styledSelect":"AdminUpdatePoints_styledSelect__IjKJD"};